import { store } from 'Store/store';
import {
  state,
  getters,
  actions,
  mutations
} from './PersistedStore.js';
import { vuePresist } from 'Store/plugin/vuePresist';
if (!store.hasModule('bizgainOnboarding')) {
  store.registerModule('bizgainOnboarding', {
    state,
    getters,
    actions,
    mutations
  });
  vuePresist(store, 'bizgain-onboarding', ['bizgainOnboarding']);
}

